<label [for]="'Field:' + model.Id" class="form_label"> {{ model.Label }}
    <sm-help-tooltip *ngIf="model.HelpText">{{ model.HelpText }}</sm-help-tooltip>
    <span *ngIf="!model.Required" class="text-muted font-italic form_label--optional"> optional</span>
</label>